import { Action, createAction, props } from '@ngrx/store';
import { SignalrMessageModel } from '../models/SignalrMessageModel';

export const ADD_Message = '[SignalrMessageModel] Add';
export const REMOVE_Message = '[Message] Remove';
export const CLEAR_Store = '[] Clear';

export const AddMessage = createAction(ADD_Message, props<{ payload: SignalrMessageModel }>());

export const RemoveMessage = createAction(REMOVE_Message, props<{ payload: SignalrMessageModel }>());

export const ClearStore = createAction(CLEAR_Store);
